<div class="manage-categories-container">

  <header class="page-header">
    <h1 class="page-title">Gestión De Categorías</h1>

    <div class="header-actions">
      <app-search-bar
        placeholder="Buscar"
        (search)="onSearch($event)"
      />
      <button type="button" class="btn-primary" (click)="onAdd()">
        Añadir Categoría
      </button>
    </div>
  </header>

  @if (errorMessage()) {
    <div class="inline-error" role="alert">{{ errorMessage() }}</div>
  }

  <div class="table-container">
    <table class="admin-table">
      <thead>
        <tr>
          <th class="col-photo">Foto</th>
          <th class="col-name">Nombre</th>
          <th class="col-parent col-parent--hide-mobile">Categoría Padre</th>
          <th class="col-actions">Editar</th>
        </tr>
      </thead>

      <tbody>
        @if (isLoading()) {
          <tr>
            <td colspan="4" class="state-row">Cargando categorías...</td>
          </tr>
        } @else if (isEmpty()) {
          <tr>
            <td colspan="4" class="state-row">No hay categorías.</td>
          </tr>
        } @else if (rows().length === 0) {
          <tr>
            <td colspan="4" class="state-row">
              Sin resultados para «{{ searchTerm() }}».
            </td>
          </tr>
        } @else {
          @for (row of rows(); track trackByRow($index, row)) {
            @if (row.kind === 'category') {
              <tr class="category-row" [class.is-child]="row.depth > 0">
                <td class="col-photo">
                  @if (getCategoryImage(row.category); as imgSrc) {
                    <img
                      [src]="imgSrc"
                      [alt]="row.category.name"
                      class="category-thumb"
                    />
                  } @else {
                    <div class="category-thumb category-thumb--placeholder"></div>
                  }
                </td>

                <td class="col-name">
                  <div
                    class="name-cell"
                    [style.paddingLeft.px]="row.depth * 24"
                  >
                    @if (row.depth > 0) {
                      <span class="nesting-icon" aria-hidden="true">↳</span>
                    }
                    <span class="category-name" [class.is-bold]="row.depth === 0">
                      {{ row.category.name }}
                    </span>
                  </div>
                </td>

                <td class="col-parent">
                  @if (row.category.parentId) {
                    <span class="parent-name">{{ getParentName(row.category) }}</span>
                  } @else {
                    <span class="muted">-</span>
                  }
                </td>

                <td class="col-actions">
                  <button
                    type="button"
                    class="action-link action-link--edit"
                    (click)="onEdit(row.category)"
                  >
                    Editar
                  </button>
                  @if (isProtectedCategory(row.category)) {
                    <span
                      class="protected-badge"
                      title="Categoría del sistema: no se puede borrar, renombrar ni mover"
                    >
                      Protegida
                    </span>
                  } @else {
                    <button
                      type="button"
                      class="action-link action-link--delete"
                      (click)="onDelete(row.category)"
                    >
                      Borrar
                    </button>
                  }
                </td>
              </tr>
            } @else {
              <tr class="add-child-row">
                <td colspan="4">
                  <button
                    type="button"
                    class="add-child-btn"
                    (click)="onAddChild(row.parent)"
                  >
                    + Agregar Subcategoria
                  </button>
                </td>
              </tr>
            }
          }
        }
      </tbody>
    </table>
  </div>

</div>
